// extracted by mini-css-extract-plugin
export default {"icon":"FindGroup-module-cdf940784756791e485c"};